import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IKnowladgeGraphDifferences } from '../../../../../../interface/interfaces';

interface IInitialState {
    knowledgeGraphForSendingData: IKnowladgeGraphDifferences | null;
}

const initialState: IInitialState = {
    knowledgeGraphForSendingData: null,
};

const knowledgeGraphForSendingSlice = createSlice({
    name: 'knowledgeGraphForSending',
    initialState,
    reducers: {
        addKnowledgeGraph: (state: IInitialState, action: PayloadAction<IKnowladgeGraphDifferences>) => {
            state.knowledgeGraphForSendingData = action.payload;
        },
        updateKnowledgeGraph: (state: IInitialState, action: PayloadAction<string>) => {
            if (state.knowledgeGraphForSendingData) {
                // state.knowledgeGraphForSendingData.instances[Symbol]........
            }
        },
        clearKnowledgeGraph: (state: IInitialState) => {
            state.knowledgeGraphForSendingData = null;
        },
    },
});

export default knowledgeGraphForSendingSlice.reducer;
export const { addKnowledgeGraph, updateKnowledgeGraph, clearKnowledgeGraph } = knowledgeGraphForSendingSlice.actions;
